export var OPTION_POSTFIX_TESTID = 'option';
export var RESET_SELECTED_OPTIONS_BUTTON_POSTFIX_TESTID = 'resetSelectedOptionsButton';
export var CREATE_OPTION_BUTTON_TESTID = 'createOptionButtonLocator';
export var CLOSE_OPTIONS_LIST_BUTTON_POSTFIX_TESTID = 'closeOptionsListButtonPostfix';
